import { cn } from '@/ui/utils/style'

interface ApyChangeProps {
  currentAPY: number
  newAPY: number
  /** 'earning' = higher is better (supply), 'cost' = lower is better (borrow) */
  type: 'earning' | 'cost'
  className?: string
}

/**
 * Displays an APY change arrow with color coding:
 * - earning (supply): green if APY goes up, amber if down
 * - cost (borrow): green if APY goes down, amber if up
 */
export function ApyChange({ currentAPY, newAPY, type, className }: ApyChangeProps) {
  const isBetter = type === 'earning' ? newAPY >= currentAPY : newAPY <= currentAPY

  return (
    <span className={cn('inline-flex items-center', className)}>
      <span className="text-muted-foreground">→</span>{' '}
      <span className={cn('transition-colors duration-300', isBetter ? 'text-green-400' : 'text-amber-400')}>
        {newAPY.toFixed(2)}%
      </span>
    </span>
  )
}
